export default function Marquee({ items = [], className = "" }) {
  const sequence = [...items, ...items];
  return (
    <div className={`relative overflow-hidden whitespace-nowrap ${className}`}>
      <div className="inline-flex animate-[marquee_38s_linear_infinite] gap-10">
        {sequence.map((item, i) => (
          <span
            key={i}
            className="font-serif text-2xl md:text-4xl font-light uppercase tracking-wide inline-flex items-center gap-10"
          >
            {item}
            <span className="text-bronze">✦</span>
          </span>
        ))}
      </div>
      <style>{`
        @keyframes marquee {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
      `}</style>
    </div>
  );
}
